import ResolvedIssuesStore from '../../resolved-issues/stores/resolved-issues-store';
import { createIssuesActions } from '../../common/actions/create-issues-actions';
import resolvedIssuesService from '../services';
import * as storeActions from '../store-actions/resolved-issue-store-actions';
import { AppPages } from '../../../common/routing/app-navigator';

const resolvedIssuesActions = createIssuesActions(
  ResolvedIssuesStore,
  resolvedIssuesService,
  storeActions,
  AppPages.ResolvedIssues,
);

// export actions individually
export const loadIssuesResolved = resolvedIssuesActions.loadIssues;
export const loadFiltersResolved =
  resolvedIssuesActions.loadFiltersWithoutSearch;
export const setIssueDrawerResolved = resolvedIssuesActions.setIssueDrawer;
export const clearSelectedIssueResolved =
  resolvedIssuesActions.clearSelectedIssue;
export const setLoadingIssueResolved = resolvedIssuesActions.setLoadingIssue;
export const handleIssueRowClickResolved =
  resolvedIssuesActions.handleIssueRowClick;
export const sortIssuesResolved = resolvedIssuesActions.sortIssues;
export const handleSearchFilterTypeResolved =
  resolvedIssuesActions.handleSearchFilterTypeWithoutAtlasSearch;
export const initIssuesResolved = resolvedIssuesActions.initIssues;
export const setMenuIssueIdResolved = resolvedIssuesActions.setMenuIssueId;
